import { mutatorAction } from 'satcheljs';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export default mutatorAction('setFocusedRowKey', function setFocusedRowKey(tableView, focusedRowKey) {
    if (isMailFeatureEnabled('tri-selectionRefactor')) {
        tableView.focusedRowKey = focusedRowKey;
    }
    else {
        tableView.selectionAnchorItemId = focusedRowKey;
    }
});
//# sourceMappingURL=setFocusedRowKey.js.map